<div class="flex flex-col h-full w-full overflow-hidden">
    <!-- Header section with logo and close button -->
    <div class="flex justify-between items-center p-4 sm:p-6 h-auto">
      <!-- Logo -->
      <div class="w-40 h-auto">
          <img class="w-90 h-auto" src="images/logo/logo.svg" alt="Logo" />
      </div>
  
      <!-- Close button -->
    <button mat-icon-button mat-dialog-close (click)="closeDialog()" class="icon-size-2" *ngIf="shouldShowCloseButton()">
        <mat-icon>close</mat-icon>
    </button>
    
    </div>

    <!-- Content section - takes full available height -->
    <div class="flex-grow flex flex-col justify-between px-4 sm:px-8">
        <!-- Title and description -->
        <div class="text-center pt-2 sm:pt-6 mb-4 sm:mb-8">
            <h1 class="text-3xl sm:text-3xl font-bold">{{ 'login.title' | transloco:titleParams}}</h1>
            <p class="text-base sm:text-base text-gray-500 mt-2">{{'register.alreadyRegistered' | transloco}}</p>
        </div>
        
        <!-- Form section - will expand to fill available space -->
         
        
    <div class="flex-grow flex flex-col justify-center items-center ">
        <form [formGroup]="loginSessionForm" class="w-full">
            <div class="w-full max-w-2xl floating-label relative">
            <input
                id="password"
                type="password"
                [formControl]="loginSessionForm.get('password')"
                [placeholder]="'login.passwordPlaceholder' | transloco"
                class="placeholder-base w-full px-4 py-3 border border-gray-300 rounded-lg"
                #passwordField
            />
            <label for="password" class="floating-label">{{'login.passwordPlaceholder' | transloco}}</label>
            <button
                type="button"
                (click)="
                    passwordField.type === 'password'
                        ? (passwordField.type = 'text')
                        : (passwordField.type = 'password')
                "
                class="absolute right-2 top-[2.2rem] transform -translate-y-1/2"
            >
                @if (passwordField.type === 'password') {
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_solid:eye'"
                    ></mat-icon>
                }
                @if (passwordField.type === 'text') {
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_solid:eye-slash'"
                    ></mat-icon>
                }
            </button>
            <div *ngIf="loginSessionForm.get('password')?.invalid && loginSessionForm.get('password')?.touched" 
                 class="text-red-600 text-base mt-1 flex items-center">
                 <mat-icon class="text-red-500 mr-1" style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
                 <span>{{ getPasswordErrorMessage() }}</span>
            </div>
        </div>

                <!-- Forgot password section -->
                <div class="flex items-center justify-end space-x-2 mt-2 mb-6">
                    <p class="text-base sm:text-base text-gray-500">
                        {{'login.forgotPassword' | transloco}}
                        <button (click)="openOtpDialog()" class="text-[#006E75] hover:text-[#003E42] hover:underline underline-offset-2">
                            {{'login.sendOTPmsg' | transloco}}
                        </button>
                    </p>
                    <mat-icon
                        [matTooltip]="'login.toolTip' | transloco"
                        matTooltipPosition="right"
                        matTooltipClass="custom-tooltip"
                        class="question-icon ml-2 inline-flex items-center justify-center" 
                        style="width: 20px; height: 20px; font-size: 14px; line-height: 20px; vertical-align: middle; background: #4B5A5B;">
                        ?
                    </mat-icon>
                </div>
            </form>
            
        </div>
            
        
        <!-- Button section -->
        <div class="w-full max-w-md mx-auto mt-auto pb-6 sm:pb-8 pt-4 sm:pt-6">
            <div *ngIf="passwordApiError" class="flex justify-center items-center min-h-[24px] sm:min-h-[28px] mb-4">
            <div class="text-base text-center rounded-md px-4 py-2 w-full">
                <p class="text-red-600 text-base sm:text-base font-medium">{{ passwordApiError }}</p>
            </div>
            </div>
            <button
                (click)="login()"
                class="my-button fuse-mat-button-large w-full py-3 sm:py-4 rounded-full bg-teal-700 text-white font-semibold text-base sm:text-base transition shadow h-12 sm:h-14"
            >
                {{'login.loginBtn' | transloco}}
            </button>
        </div>
    </div>
</div>